import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { db } from '../firebase';
import { collection, query, where, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import StatusColumn from '../components/features/StatusColumn';
import { TeslimFormu } from '../components/features/TeslimFormu';
import PageHeader from '../components/common/PageHeader';
import { Loading } from '../components/common/Loading';

const statuses = ["Beklemede", "İşlemde", "Tamamlandı", "Teslime Hazır"];

const ServisPanosu = () => {
  const [serviceRecords, setServiceRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recordToPrint, setRecordToPrint] = useState(null);
  const printRef = useRef();

  // YENİ: Mobil ekran kontrolü
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));



  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
      setRecordToPrint(null);
    }
  });

  useEffect(() => {
    if (recordToPrint) {
      handlePrint();
    }
  }, [recordToPrint, handlePrint]);

  useEffect(() => {
    const q = query(collection(db, "serviceRecords"), where("durum", "in", statuses));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setServiceRecords(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    }, (error) => {
      console.error("Servis kayıtları çekilirken hata oluştu: ", error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleStatusChange = async (recordId, newStatus) => {
    const recordRef = doc(db, "serviceRecords", recordId);
    try {
      await updateDoc(recordRef, { durum: newStatus });
    } catch (e) {
      console.error("Durum güncellenirken hata oluştu: ", e);
    }
  };

  const handleMarkAsDelivered = async (recordId) => {
    if (window.confirm("Bu cihaz müşteriye teslim edildi olarak işaretlenecek ve servis panosundan kaldırılacak. Önce teslim formu yazdırılacak. Onaylıyor musunuz?")) {
      const record = serviceRecords.find(sr => sr.id === recordId);
      if (record) {
        const recordRef = doc(db, "serviceRecords", recordId);
        try {
          await updateDoc(recordRef, { durum: "Teslim Edildi" });
          setRecordToPrint(record);
        } catch (e) {
          console.error("Cihaz teslim edilirken hata oluştu: ", e);
          alert("Cihaz durumu güncellenirken bir hata oluştu.");
        }
      }
    }
  };

  const getRecordsByStatus = (status) => {
    return serviceRecords.filter(sr => sr.durum === status);
  };

  if (loading) { return <Loading message="Servis panosu yükleniyor..." />; }

  return (
    <Box sx={{ p: { xs: 1, md: 1 } }}>
      <Box sx={{ display: 'none' }}>
        <TeslimFormu ref={printRef} workOrder={recordToPrint} />
      </Box>

      {/* Header Eklendi/Düzenlendi */}
      {!isMobile && (
        <PageHeader
          title="Teknik Servis Panosu"
          subtitle="Cihazların anlık durumlarını buradan takip edip yönetebilirsiniz."
          icon={<ViewKanbanIcon />}
        />
      )}

      {/* GÜNCELLENDİ: sx prop'u ile mobil ve masaüstü için farklı layout */}
      <Box sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: 1,
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        height: isMobile ? 'auto' : 'calc(100vh - 180px)',
        maxHeight: isMobile ? 'none' : 'calc(100vh - 180px)',
      }}>
        {statuses.map(status => (
          <Box key={status} sx={{
            flex: isMobile ? '1 1 auto' : '1 1 0',
            minWidth: isMobile ? 'unset' : 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100%', // YENİ: Yüksekliğin parent kadar olması garanti edildi
            overflow: 'hidden' // YENİ: Taşan içeriğin gizlenmesi ve scroll'un child'a bırakılması
          }}>
            <StatusColumn
              title={status}
              workOrders={getRecordsByStatus(status)}
              allStatuses={statuses}
              onStatusChange={handleStatusChange}
              onMarkAsDelivered={handleMarkAsDelivered}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ServisPanosu;